import React from 'react';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const InvoicesWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.status} className="mydesk-group"><strong>{g.count}</strong> {g.label}</span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>No open invoices.</WidgetEmpty>}
      {items.map((i) => (
        <WidgetRow
          key={i.key}
          icon={faFileInvoiceDollar}
          tone={i.status_tone === 'error' ? 'error' : i.status_tone === 'pending' ? 'warn' : 'brand'}
          title={i.partner_name || i.number}
          subtitle={[i.kind_label, i.number, i.amount, i.due_label ? `due ${i.due_label}` : ''].filter(Boolean).join(' · ')}
          right={(
            <>
              <Pill tone={i.status_tone || 'neutral'}>{i.status_label}</Pill>
              <Age>{i.age_label}</Age>
            </>
          )}
          onClick={() => goTo(i.url)}
        />
      ))}
      <WidgetFooter label="Open Financials" url={data.url} />
    </>
  );
};

export default InvoicesWidget;
